export const CIS_INTERNAL = 'CIS_INTERNAL';
export const USER = 'USER';
export const RISK_MESSENGER = 'riskMessenger';
export const IBANK = 'iBank';

export const IS_PROD = ['production', 'prodstage', 'etsNext'].includes(
  process.env.ENVIRONMENT
);

export const IS_DEV = ['localhost', 'development', 'stage'].includes(
  process.env.ENVIRONMENT
);

if (!IS_PROD && !IS_DEV) {
  throw new Error(
    'Invalid .env.ENVIRONMENT. Must be of values: development, stage, production, prodstage, etsNext'
  );
}

export const IS_ETS_NEXT =
  process.env.IS_ETS_NEXT === 'true' ||
  process.env.NEXT_PUBLIC_IS_ETS_NEXT === 'true';

// I removed the env variable. For local development, please change the value here.
// If you are reading a code review and the line below is changed, please ensure it was intentional.
export const IBANK_URL = IS_PROD
  ? 'https://apps.ciswired.com'
  : 'https://apps.dev.ciswired.com';

export const IQCX_ERROR_STATES = {
  qualityControl: {
    title: 'QC Errors',
    message: 'Quality checks preventing ticketing',
  },
  alerts: {
    title: 'Alerts',
    message: 'PNR accuracy issues discovered',
  },
  exceptions: {
    title: 'Exceptions',
    message: 'Reasons PNRs were sent to reject queue',
  },
};

export const DEFAULT_LOGO = '/images/CornerstoneLogoColor.png';
export const DEFAULT_THEME_COLOR = '#040059';

export const QC_MAIL_TICKETING_CONFIG = {
  redirectBaseUrl: '/qc-mail-ticketing/tables',
  defaultValues: {
    libraryType: 'local',
    allow_api_edit: false,
  },
};

export const LIBRARIES_CONFIG = {
  isLibrary: true,
  redirectBaseUrl: '/cis-internal-tools/libraries',
  defaultValues: {
    libraryType: 'restricted',
  },
};
